import { c as create$3 } from './form.js';
import { r as revenueValidation, p as paymentVolumeValidation, w as whenServiceReceivedValidation, a as recurringPaymentsValidation, b as recurringPaymentsPercentageValidation, s as seasonalBusinessValidation, o as otherPaymentDetailsValidation } from './schema-validations.js';

const additionalQuestionsSchema = (allowOptionalFields) => {
    const schema = create$3({
        business_revenue: revenueValidation.required('Enter business revenue'),
        business_payment_volume: paymentVolumeValidation.required('Enter business payment volume'),
        business_when_service_received: whenServiceReceivedValidation.required('Select when service is received'),
        business_recurring_payments: recurringPaymentsValidation.required('Select recurring payments'),
        business_recurring_payments_percentage: recurringPaymentsPercentageValidation,
        business_seasonal: seasonalBusinessValidation.required('Select business seasonal'),
        business_other_payment_details: otherPaymentDetailsValidation.nullable(),
    });
    const easySchema = create$3({
        business_revenue: revenueValidation.nullable(),
        business_payment_volume: paymentVolumeValidation.nullable(),
        business_when_service_received: whenServiceReceivedValidation.nullable(),
        business_recurring_payments: recurringPaymentsValidation.nullable(),
        business_recurring_payments_percentage: recurringPaymentsPercentageValidation,
        business_seasonal: seasonalBusinessValidation.nullable(),
        business_other_payment_details: otherPaymentDetailsValidation.nullable(),
    });
    return allowOptionalFields ? easySchema : schema;
};

export { additionalQuestionsSchema as a };
